import { api } from '@/global/api'
import {
  EstablishmentsArgs,
  PositionType,
  EstablishmentCategory
} from '@/modules/accredited-establishments/api/types'
import { constructFilterObject } from '@/modules/accredited-establishments/functions/constructFilterObject'

export interface EstablishmentMarker {
  referencedId: string
  category: EstablishmentCategory
  icon?: string
  lat: string
  lon: string
}

export interface SearchAccreditedEstablishmentMarkersResponse {
  items: EstablishmentMarker[]
  searchPosition: {
    lat: string
    lon: string
    type?: PositionType
  }
}

export type SearchAccreditedEstablishmentMarkersArgs = EstablishmentsArgs

export const searchEstablishmentMarkers = async ({
  ...args
}: SearchAccreditedEstablishmentMarkersArgs): Promise<SearchAccreditedEstablishmentMarkersResponse> => {
  const filter = constructFilterObject(args)
  const { data } = await api.get<SearchAccreditedEstablishmentMarkersResponse>(
    `/site_accredited_network/accredited/lightweight?filter=${JSON.stringify(
      filter
    )}`
  )
  return data
}
